<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("distributor", 1) }} {{ $t("contract") }}
      </div>
      <router-link class="btn-blue" to="distributor-contract"
        >{{ $tc("distributor", 1) }} {{ $t("contract") }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <!-- Cinemas -->
          <div class="col-lg-6 col-xl-4 mb-4">
            <div class="dropdown-curve-container">
              <!-- <label
                :class="selectedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectcine_1"
                  id="selectcine_1"
                >
                  <b-dropdown-item
                    v-for="(Cinema, CinemaIndex) in Cinemas"
                    :key="CinemaIndex"
                    v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item>
                </b-dropdown>
                <Tooltip :title="$t('cinemadesignationscontract')" />
              </div> -->
              <multiselect
                :options="Cinemas"
                v-model="selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_name"
                placeholder="Select Cinema"
                :preselect-first="true"
                @select="onSelectCinema(null, $event)"
              />
              <p
                v-if="submitted && selectedCinema.length == 0"
                class="error_message"
              >
                {{ messagecinema }}
              </p>
            </div>
          </div>

          <!-- Movies -->
          <div class="col-lg-6 col-xl-4 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <multiselect
                  v-model="distributorContracts.md_id_list"
                  @select="onSelectMovie"
                  :placeholder="dropdowntext"
                  :options="Movies"
                  label="movie"
                  track-by="md_id"
                  name="selectmovie_1"
                  id="selectmovie_1"
                  :multiple="true"
                  v-validate
                  data-vv-rules="required"
                  data-vv-name="md_id"
                  data-vv-value-path="md_id"
                ></multiselect>
              </div>
              <Tooltip :title="$t('moviedesignationcontract')" />
            </div>
            <p v-show="errors.has('md_id')" class="error_message">
              {{ errors.first("md_id") }}
            </p>
          </div>
          <!-- Distributors -->
          <div class="col-lg-6 col-xl-4 mb-4">
            <div class="dropdown-curve-container">
              <!-- <label :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("distributor", 1) }}</label
              > -->
              <div class="d-flex justify-content-center align-items-center">
                <!-- <b-dropdown
                  :text="selectedDistributor"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectdistri_1"
                  id="selectdistri_1"
                >
                  <b-dropdown-item
                    v-for="(Distributor, DistributorIndex) in Distributors"
                    :key="DistributorIndex"
                    v-on:click="onSelectDistributor($event, Distributor)"
                    >{{ Distributor.d_company_name }}</b-dropdown-item
                  > -->
                <!-- <b-dropdown-item v-on:click="onSelectDistributor('Spiderman')">MovieBuff</b-dropdown-item> -->
                <!-- </b-dropdown> -->
                <multiselect
                  :options="Distributors"
                  v-model="selectedDistributor"
                  :searchable="true"
                  label="d_company_name"
                  track-by="d_company_name"
                  placeholder="Select Distributor"
                  :preselect-first="true"
                  @select="onSelectDistributor($event)"
                />
                <Tooltip :title="$t('distributordesignationname')" />
              </div>
              <p
                v-if="submitted && selectedDistributor.length == 0"
                class="error_message"
              >
                {{ messagecinema }}
              </p>
            </div>
          </div>

          <div
            class="col-12 mb-3 mt-4"
            v-for="(distributorWeeklyContract,
            distributorWeeklyContractIndex) in distributorWeeklyContracts"
            :key="distributorWeeklyContractIndex"
          >
            <div class="p-3 border rounded-10">
              <div class="row">
                <div class="col-lg-10 col-xl-11">
                  <div class="row">
                    <div class="col-lg-12 mb-3">
                      <h6 class="mb-0">
                        {{ $tc("distributor", 1) }} {{ $t("contract") }}
                        {{ $tc("details", 2) }}
                      </h6>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="distributorWeeklyContract.dc_from_date"
                            v-on:click="clearSelectedDate()"
                          >
                            ✖
                          </button>
                          <Datepicker :monday-first="true"
                            ref="programaticOpen"
                            v-model="distributorWeeklyContract.dc_from_date"
                            @selected="
                              doSomethingInParentComponentFunction(
                                $event,
                                distributorWeeklyContractIndex
                              )
                            "
                            name="selectfromdate_1"
                            id="selectfromdate_1"
                            v-validate="'required'"
                          ></Datepicker>
                          <label
                            :class="
                              distributorWeeklyContract.dc_from_date
                                ? 'active'
                                : ''
                            "
                            >From Date</label
                          >
                        </div>
                        <p
                          v-if="submitted && errors.has('selectfromdate_1')"
                          class="error_message"
                        >
                          {{ errors.first("selectfromdate_1") }}
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="distributorWeeklyContract.dc_to_date"
                            v-on:click="clearSelectedDate()"
                          >
                            ✖
                          </button>
                          <Datepicker :monday-first="true"
                            disabled
                            ref="programaticOpen"
                            v-model="distributorWeeklyContract.dc_to_date"
                            name="selectenddate_1"
                            id="selectenddate_1"
                            v-validate="'required'"
                          ></Datepicker>
                          <label
                            :class="
                              distributorWeeklyContract.dc_to_date
                                ? 'active'
                                : ''
                            "
                            >To Date</label
                          >
                        </div>
                        <p
                          v-if="submitted && errors.has('selectenddate_1')"
                          class="error_message"
                        >
                          {{ errors.first("selectenddate_1") }}
                        </p>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            distributorWeeklyContract
                              .selectedDistributorShareType.length > 0
                              ? 'shift-up'
                              : ''
                          "
                          >{{ $t("select") }} {{ $tc("sharetype", 1) }}</label
                        >
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <b-dropdown
                            :text="
                              distributorWeeklyContract.selectedDistributorShareType
                            "
                            variant="dropdown-curve"
                            class="w-100"
                            name="selectdistrisharetype"
                            id="selectdistrisharetype"
                          >
                            <b-dropdown-item
                              v-for="(DistributorShareType,
                              DistributorShareTypeIndex) in DistributorShareTypes"
                              :key="DistributorShareTypeIndex"
                              v-on:click="
                                onSelectDistributorShareType(
                                  $event,
                                  DistributorShareType,
                                  distributorWeeklyContractIndex
                                )
                              "
                              >{{
                                DistributorShareType.dst_label
                              }}</b-dropdown-item
                            >
                            <!-- <b-dropdown-item v-on:click="onSelectDistributorShareType('Spiderman')">MovieBuff</b-dropdown-item> -->
                          </b-dropdown>
                          <Tooltip :title="$t('sharetypedesignationname')" />
                        </div>
                        <p
                          v-if="
                            submitted &&
                              distributorWeeklyContract
                                .selectedDistributorShareType.length == 0
                          "
                          class="error_message"
                        >
                          {{ messagedistributor }}
                        </p>
                        <br />
                        <span>{{
                          distributorWeeklyContract.dst_share_type_description
                        }}</span>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <div class="row">
                        <div class="col-6 align-self-center">
                          <label class="mb-0">Share Percentage Message</label>
                        </div>
                        <div class="col-6">
                          <div class="input-material">
                            <input
                              v-model="distributorWeeklyContract.dc_share_value"
                              type="text"
                              step="any"
                              name="sharevalue_1"
                              id="sharevalue_1"
                              v-validate="'required|numeric'"
                            />
                            <label>{{ $t("shareValue") }}</label>
                          </div>
                        </div>
                      </div>

                      <p
                        v-if="submitted && errors.has('sharevalue_1')"
                        class="error_message"
                      >
                        {{ errors.first("sharevalue_1") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-2 col-xl-1 border-left d-flex justify-content-center align-items-center"
                >
                  <button
                    v-if="distributorWeeklyContractIndex === 0"
                    @click.stop.prevent="addMoreDistributorWeeklyContracts"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                  <button
                    v-if="
                      distributorWeeklyContractIndex === 0 &&
                        distributorWeeklyContracts.length !== 1
                    "
                    @click.stop.prevent="
                      removeMoreDistributorWeeklyContracts(
                        distributorWeeklyContractIndex
                      )
                    "
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                  <button
                    v-if="distributorWeeklyContractIndex !== 0"
                    @click.stop.prevent="
                      removeMoreDistributorWeeklyContracts(
                        distributorWeeklyContractIndex
                      )
                    "
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 text-center pt-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit"
              class="btn-blue"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      dropdowntext: "Select Movie",
      messagemovie: "Please Select Movie.",
      messagecinema: "Please Select Cinema",
      messagedistributor: "Please Select Distributor Share Type",
      submitted: false,
      // Saif
      Cinemas: [],
      Movies: [],
      Distributors: [],
      DistributorShareTypes: [],
      distributorContracts: {
        cinema_id: null,
        md_id: null,
        md_id_list: [],
        distributor_id: null,
        dc_id: null,
        dc_is_active: "Y",
        updated_by: "",
        updated_at: "",
        created_at: "",
        created_by: ""
      },
      distributorWeeklyContracts: [
        {
          dc_from_date: null,
          dc_to_date: null,
          dc_from_date_timestamp: "",
          dc_to_date_timestamp: "",
          distributor_share_type_id: null,
          selectedDistributorShareType: "",
          dc_share_value: null
        }
      ],
      selectedCinema: "",
      selectedMovie: "Select Movie",
      selectedDistributor: "",
      selectedDistributorShareType: "Select Distributor Share Type"

      // Saif
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getMoviesList();
    this.getDistributorShareTypesList();
    // this.getDistributorsList();
  },
  watch: {},
  mounted() {},
  methods: {
    // Saif
    getCinemaList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id
                });
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getMoviesList: function() {
      MovieService.GetActiveMoviesWithFormat()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Movies = data.Records;
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getDistributorsList: function(movie_id) {
      DistributorService.GetDistributorContractByMovieId({ movie_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
      // DistributorService.GetActiveDistributors({ activekey: "d_is_active" })
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       this.Distributors = data.Records;
      //     } else {
      //       // Show Error Message
      //       console.log("data.message :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Catch On GetActiveCinemas :", error);
      //   });
    },
    getDistributorShareTypesList: function() {
      DistributorService.GetActiveDistributorShareTypes({
        activekey: "dst_is_active"
      })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.DistributorShareTypes = data.Records;
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          let payload = {
            ...this.distributorContracts,
            DistributorWeeklyContracts: this.distributorWeeklyContracts
          };
          DistributorService.AddDistributorContract(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/distributor/distributor-contract"
                });
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
    onSelectCinema: function(event, params) {
      this.selectedCinema = params.cine_name;
      this.distributorContracts.cinema_id = params.cine_id;
    },
    onSelectMovie: function(event) {
      // console.log(
      //   "distributorContracts.md_id_list :",
      //   this.distributorContracts.md_id_list
      // );
      // // this.selectedMovie = params.movie;
      // // this.distributorContracts.md_id = params.md_id;

      let array = [...this.distributorContracts.md_id_list, event];
      let ids = array.map(x => x.md_id).toString();
      ids.length > 0 ? this.getDistributorsList(ids) : "";
    },
    onSelectDistributor(distributor) {
      this.selectedDistributor = distributor.d_company_name;
      this.distributorContracts.distributor_id = distributor.d_id;
    },
    onSelectDistributorShareType: function(
      event,
      params,
      distributorWeeklyContractIndex
    ) {
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].selectedDistributorShareType = params.dst_label;
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].distributor_share_type_id = params.dst_id;
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].dst_share_type_description = params.dst_share_type_description;
    },
    addMoreDistributorWeeklyContracts: function() {
      this.distributorWeeklyContracts.push({
        dc_from_date: null,
        dc_to_date: null,
        dc_from_date_timestamp: "",
        dc_to_date_timestamp: "",
        distributor_share_type_id: null,
        selectedDistributorShareType: "",
        dc_share_value: 0,
        dst_share_type_description: null
      });
    },
    removeMoreDistributorWeeklyContracts: function(index) {
      this.distributorWeeklyContracts.splice(index, 1);
    },
    // Saif
    doSomethingInParentComponentFunction: function(event, index) {
      // dc_from_date_timestamp: "",
      // dc_to_date_timestamp: "",
      let days = 6;
      this.distributorWeeklyContracts[index].dc_from_date = event;
      let date = new Date(event);
      let final = date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      this.distributorWeeklyContracts[index].dc_to_date = new Date(final);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorContractComponents/addDistributorContract.vue